import type { InvoiceHeader } from '../services/invoiceApi';

function firstNonEmptyString(...candidates: unknown[]): string {
  for (const c of candidates) {
    if (c == null) continue;
    const s = String(c).trim();
    if (s) return s;
  }
  return '';
}

/** True when e-invoice supply type is an export variant (EXP*, DEXP, etc.). */
export function isInvoiceExportSupplyType(
  invoice: Pick<InvoiceHeader, 'supTyp' | 'supplyType'> | Record<string, unknown>
): boolean {
  const inv = invoice as Record<string, unknown>;
  const code = firstNonEmptyString(inv.supTyp, inv.supplyType, inv.sup_typ);
  const u = code.toUpperCase();
  return u.startsWith('EXP') || u === 'DEXP';
}

/**
 * Text for export country on print / view (name + code when both exist, else code or name, else numeric id).
 */
export function getInvoiceExportCountryDisplayLine(
  invoice: InvoiceHeader | Record<string, unknown>
): string {
  const inv = invoice as Record<string, unknown>;
  const name = firstNonEmptyString(
    inv.exportCountryName,
    inv.countryName,
    inv.buyerCountryName,
    inv.export_country_name
  );
  const code = firstNonEmptyString(
    inv.exportCountryCode,
    inv.countryCode,
    inv.export_country_code
  );
  if (name && code && name.toUpperCase() !== code.toUpperCase()) return `${name} (${code})`;
  if (name) return name;
  if (code) return code;
  const idRaw = inv.exportCountryId ?? inv.countryId ?? inv.export_country_id ?? inv.country_id;
  const id = idRaw != null ? Number(idRaw) : NaN;
  if (!Number.isNaN(id) && id > 0) return String(id);
  return '';
}
